<template>
  <div class="page-content" style="padding-top: 2.5rem">
    <div class="container-fluid">
      <div class="row" style="margin-top: 2rem">
        <div class="col-xxl-12">
          <div class="d-flex flex-column h-100">
            <div class="row">
              <div class="col-md-5" style="text-align: left">
                <h5><strong>Bus Details : TN15 Y 3132</strong></h5>
                <h6>&nbsp;<strong>Owner No: 9585021432</strong></h6>
              </div>
              <div class="col-md-7" style="text-align: right; display: flex">
                <div class="search-box" style="width: 60%">
                  <input type="date" class="form-control search" />
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <button
                  type="button"
                  class="btn btn-success add-btn"
                  style="height: 2.5rem"
                >
                  Search
                </button>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <button
                  type="button"
                  class="btn btn-warning add-btn"
                  style="height: 2.5rem"
                >
                  Veiw Bus Details
                </button>
              </div>
              <div class="col-md-12"><br /></div>
              <div class="col-md-3">
                <a href="/bookings">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">Revenue</p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="28.05">
                              ₹1.63L
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-ticket-2-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-2">
                <a href="/bookings">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">Bookings</p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              0
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-close-circle-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-md-2">
                <a href="/bookings">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Cancellations
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              0
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-bookmark-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-md-2">
                <a href="/bookings">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">Staffs</p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              0
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-line-chart-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-md-3">
                <a href="/bookings">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">Ratings</p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              4.3
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-line-chart-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-6">
                <div class="card">
                  <div class="card-body" style="padding: 1.3rem">
                    <div class="table-responsive table-card mb-1">
                      <table
                        class="table table-nowrap align-middle"
                        id="orderTable"
                      >
                        <thead class="text-muted table-light">
                          <tr class="text-uppercase">
                            <th class="sort desc" data-sort="id">Date</th>
                            <th class="sort" data-sort="customer_name">
                              Bookings
                            </th>
                            <th class="sort" data-sort="product_name">
                              Earnings
                            </th>
                            <th class="sort" data-sort="date">Cancellations</th>
                            <th class="sort" data-sort="amount">
                              Day Wise Report
                            </th>
                          </tr>
                        </thead>
                        <tbody class="list form-check-all">
                          <tr v-for="n in numIterations" :key="n">
                            <td class="customer_name">30-10-2024</td>
                            <td class="date">664</td>
                            <td class="amount">₹2,374</td>
                            <td class="payment">64</td>

                            <td class="status">
                              <span
                                class="badge badge-soft-success text-uppercase"
                              >
                                Report
                              </span>
                            </td>
                            <td>
                              <ul class="list-inline hstack gap-2 mb-0">
                                <li class="list-inline-item edit">
                                  <a
                                    href="/add_booking"
                                    class="text-primary d-inline-block edit-item-btn"
                                  >
                                    <i class="ri-pencil-fill fs-16"></i>
                                  </a>
                                </li>
                                <li class="list-inline-item">
                                  <a
                                    class="text-danger d-inline-block remove-item-btn"
                                    href="javascript:void(0)"
                                  >
                                    <i class="ri-delete-bin-5-fill fs-16"></i>
                                  </a>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="noresult" style="display: none">
                        <div class="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#405189,secondary:#0ab39c"
                            style="width: 75px; height: 75px"
                          >
                          </lord-icon>
                          <h5 class="mt-2">Sorry! No Result Found</h5>
                          <p class="text-muted">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end">
                      <div
                        class="pagination-wrap hstack gap-2"
                        style="display: flex"
                      >
                        <a class="page-item pagination-prev disabled" href="#">
                          Previous
                        </a>
                        <ul class="pagination listjs-pagination mb-0">
                          <li class="active">
                            <a class="page" href="#" data-i="1" data-page="8"
                              >1</a
                            >
                          </li>
                          <li>
                            <a class="page" href="#" data-i="2" data-page="8"
                              >2</a
                            >
                          </li>
                        </ul>
                        <a class="page-item pagination-next" href="#"> Next </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header border-0 align-items-center d-flex">
                    <h4 class="card-title mb-0 flex-grow-1">Revenue Trends</h4>
                  </div>

                  <div class="card-body p-0 pb-2">
                    <div>
                      <apexchart
                        type="bar"
                        :options="chartOptions1"
                        :series="series1"
                      >
                      </apexchart>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header border-0">
                    <div
                      class="d-flex align-items-center"
                      style="text-align: left"
                    >
                      <div
                        class="card-body border border-dashed border-end-0 border-start-0"
                      >
                        <form>
                          <div class="row g-3">
                            <div class="col-xxl-5 col-sm-6">
                              <h5 class="card-title mb-0 flex-grow-1">
                                All Bookings
                              </h5>
                            </div>
                            <div class="col-xxl-5 col-sm-6">
                              <div class="search-box">
                                <input
                                  type="text"
                                  class="form-control search"
                                  placeholder="Enter Phone No"
                                  fdprocessedid="vrqiwe"
                                />
                                <i class="ri-search-line search-icon"></i>
                              </div>
                            </div>
                            <!--end col-->

                            <div class="col-xxl-2 col-sm-4">
                              <div>
                                <button
                                  type="button"
                                  class="btn btn-primary w-100"
                                  onclick="SearchData();"
                                  fdprocessedid="1ttz4d"
                                >
                                  <i
                                    class="ri-equalizer-fill me-1 align-bottom"
                                  ></i>
                                  Filters
                                </button>
                              </div>
                            </div>
                            <!--end col-->
                          </div>
                          <!--end row-->
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="table-responsive table-card mb-1">
                      <table
                        class="table table-nowrap align-middle"
                        id="orderTable"
                      >
                        <thead class="text-muted table-light">
                          <tr class="text-uppercase">
                            <th scope="col" style="width: 25px">
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="checkAll"
                                  value="option"
                                />
                              </div>
                            </th>
                            <th class="sort desc" data-sort="id">Ticket</th>
                            <th class="sort" data-sort="customer_name">
                              Booking Date
                            </th>
                            <th class="sort" data-sort="product_name">
                              Cx Phone Number
                            </th>
                            <th class="sort" data-sort="date">
                              From - To Location
                            </th>
                            <th class="sort" data-sort="amount">Passengers</th>
                            <th class="sort" data-sort="amount">Wallet</th>
                            <th class="sort" data-sort="amount">Total Price</th>
                            <th class="sort" data-sort="payment">Status</th>
                            <th class="sort" data-sort="payment">Action</th>
                          </tr>
                        </thead>
                        <tbody class="list form-check-all">
                          <tr v-for="n in numIterations" :key="n">
                            <th scope="row">
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  name="checkAll"
                                  value="option1"
                                />
                              </div>
                            </th>
                            <td class="customer_name">
                              <a href="/add_booking">RDF324234</a>
                            </td>
                            <td class="date">20-05-2022</td>
                            <td class="amount">+912332231121</td>
                            <td class="payment">Indore - Bhopal</td>
                            <td class="status">2</td>
                            <td class="status">50</td>
                            <td class="status">350</td>
                            <td class="status">
                              <span
                                class="badge badge-soft-success text-uppercase"
                                >Completed</span
                              >
                            </td>
                            <td>
                              <ul class="list-inline hstack gap-2 mb-0">
                                <li class="list-inline-item edit">
                                  <a
                                    href="/add_booking"
                                    class="text-primary d-inline-block edit-item-btn"
                                  >
                                    <i class="ri-pencil-fill fs-16"></i>
                                  </a>
                                </li>
                                <li class="list-inline-item">
                                  <a
                                    class="text-danger d-inline-block remove-item-btn"
                                    href="javascript:void(0)"
                                  >
                                    <i class="ri-delete-bin-5-fill fs-16"></i>
                                  </a>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="noresult" style="display: none">
                        <div class="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#405189,secondary:#0ab39c"
                            style="width: 75px; height: 75px"
                          >
                          </lord-icon>
                          <h5 class="mt-2">Sorry! No Result Found</h5>
                          <p class="text-muted">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end">
                      <div
                        class="pagination-wrap hstack gap-2"
                        style="display: flex"
                      >
                        <a class="page-item pagination-prev disabled" href="#">
                          Previous
                        </a>
                        <ul class="pagination listjs-pagination mb-0">
                          <li class="active">
                            <a class="page" href="#" data-i="1" data-page="8"
                              >1</a
                            >
                          </li>
                          <li>
                            <a class="page" href="#" data-i="2" data-page="8"
                              >2</a
                            >
                          </li>
                        </ul>
                        <a class="page-item pagination-next" href="#"> Next </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppBusDetails",
  props: {
    msg: String,
  },
  data() {
    return {
      series: [44, 55, 41, 17, 15],
      chartOptions: {
        chart: {
          type: "donut",
        },
        labels: [
          "Product A",
          "Product B",
          "Product C",
          "Product D",
          "Product E",
        ],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      numIterations: 6,
      series1: [
        {
          name: "Sales",
          data: [15, 10, 15, 35, 35, 30, 40, 30],
        },
      ],
      series2: [
        {
          data: [1010, 1640, 490, 1255, 1050, 689, 800, 420, 1085, 589],
        },
      ],

      chartOptions1: {
        chart: {
          type: "bar",
          height: 100,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [
            "Jan 1",
            "Jan 2",
            "Jan 3",
            "Jan 4",
            "Jan 5",
            "Jan 6",
            "Jan 7",
            "Jan 8",
          ],
        },
        yaxis: {
          title: {
            text: "$ (thousands)",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "$ " + val + " thousands";
            },
          },
        },
      },
      chartOptions2: {
        chart: {
          type: "bar",
          toolbar: { show: false },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        xaxis: {
          categories: [
            "India",
            "United States",
            "China",
            "Indonesia",
            "Russia",
            "Bangladesh",
            "Canada",
            "Brazil",
            "Vietnam",
            "UK",
          ],
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#00E396"],
      },
    };
  },
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
